module.exports = __webpack_public_path__ + "static/media/em-107.19ef0097.png";